import UserInvitations from './UserInvitations';

export default UserInvitations;
